import { CommonEnums } from "../../common.enums";
import { Conn_Db_Obj_Lnk } from "../conn_Db_Obj_Lnk";
import { DxFlow_Obj_Property } from "./dxflow_obj_property";
import { Obj_Db_Property } from "../datapoint/obj_db_property";
import { Conn_Db_Obj_LnksUtil } from "src/app/shared/utils/conn_db_obj_lnks.util";
import { DxFlow_Obj_PropertiesUtil } from "src/app/shared/utils/dxflow_obj_properties.util";
import { Obj_Db_PropertiesUtil } from "src/app/shared/utils/obj_db_properties.util";
import { GpsSubscriber_Inst } from "./googlesubscriber_inst";

export class GpsSubscriber {
  gpsSubscriber_Inst: GpsSubscriber_Inst;
  conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
  dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
  change_Ind: string;
  error_Cd: string;
  error_Msg: string;
  ref_Id: number;
  ref_Cd: string;
  fldr_Id: string;
  column_Properties: Array<Obj_Db_Property>;
  gps_Subscriber_Properties: Array<Obj_Db_Property>;
  target_Properties: Array<Obj_Db_Property>;

  constructor() {
    this.setDefault();
  }

  setDefault(): void {
    this.gpsSubscriber_Inst = new GpsSubscriber_Inst();
    this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
    this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
    this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
    this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
    this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    this.ref_Id = CommonEnums.defaults.LONG_VAL;
    this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
    this.fldr_Id = CommonEnums.defaults.STRING_EMPTY;
    this.column_Properties = new Array<Obj_Db_Property>();
    this.gps_Subscriber_Properties = new Array<Obj_Db_Property>();
    this.target_Properties = new Array<Obj_Db_Property>();
  }

  static parse(gpsSubcriberTmp: GpsSubscriber): GpsSubscriber {
    let googleSubcriber: GpsSubscriber = new GpsSubscriber();
    googleSubcriber.copyFrom(gpsSubcriberTmp);
    return googleSubcriber;
  }

  copy(): GpsSubscriber {
    let gpsSubcriberTmp: GpsSubscriber = new GpsSubscriber();

    gpsSubcriberTmp.gpsSubscriber_Inst = this.gpsSubscriber_Inst.copy();
    gpsSubcriberTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(
      this.conn_Db_Obj_Lnks,
    );
    gpsSubcriberTmp.dxFlow_Obj_Properties =
      DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
    gpsSubcriberTmp.change_Ind = this.change_Ind;
    gpsSubcriberTmp.error_Cd = this.error_Cd;
    gpsSubcriberTmp.error_Msg = this.error_Msg;
    gpsSubcriberTmp.ref_Id = this.ref_Id;
    gpsSubcriberTmp.ref_Cd = this.ref_Cd;
    gpsSubcriberTmp.fldr_Id = this.fldr_Id;
    gpsSubcriberTmp.column_Properties =
      Obj_Db_PropertiesUtil.getInstance().copy(this.column_Properties);
    gpsSubcriberTmp.gps_Subscriber_Properties =
      Obj_Db_PropertiesUtil.getInstance().copy(this.gps_Subscriber_Properties);
    gpsSubcriberTmp.target_Properties =
      Obj_Db_PropertiesUtil.getInstance().copy(this.target_Properties);
    return gpsSubcriberTmp;
  }

  copyFrom(gpsSubcriberTmp: GpsSubscriber): void {
    this.gpsSubscriber_Inst.copyFrom(gpsSubcriberTmp.gpsSubscriber_Inst);
    Conn_Db_Obj_LnksUtil.getInstance().copyFrom(
      this.conn_Db_Obj_Lnks,
      gpsSubcriberTmp.conn_Db_Obj_Lnks,
    );
    DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(
      this.dxFlow_Obj_Properties,
      gpsSubcriberTmp.dxFlow_Obj_Properties,
    );
    this.change_Ind = gpsSubcriberTmp.change_Ind;
    this.error_Cd = gpsSubcriberTmp.error_Cd;
    this.error_Msg = gpsSubcriberTmp.error_Msg;
    this.ref_Id = gpsSubcriberTmp.ref_Id;
    this.ref_Cd = gpsSubcriberTmp.ref_Cd;
    this.fldr_Id = gpsSubcriberTmp.fldr_Id;
    Obj_Db_PropertiesUtil.getInstance().copyFrom(
      this.column_Properties,
      gpsSubcriberTmp.column_Properties,
    );
    Obj_Db_PropertiesUtil.getInstance().copyFrom(
      this.gps_Subscriber_Properties,
      gpsSubcriberTmp.gps_Subscriber_Properties,
    );
    Obj_Db_PropertiesUtil.getInstance().copyFrom(
      this.target_Properties,
      gpsSubcriberTmp.target_Properties,
    );
  }

  compare(gpsSubcriberTmp: GpsSubscriber): string {
    let diffString = "";
    diffString = this.gpsSubscriber_Inst.compare(
      gpsSubcriberTmp.gpsSubscriber_Inst,
    );
    if (diffString != "") return diffString;

    diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(
      this.conn_Db_Obj_Lnks,
      gpsSubcriberTmp.conn_Db_Obj_Lnks,
    );
    if (diffString != "") return diffString;

    diffString = Obj_Db_PropertiesUtil.getInstance().compare(
      this.gps_Subscriber_Properties,
      gpsSubcriberTmp.gps_Subscriber_Properties,
    );
    if (diffString != "") return diffString;

    diffString = Obj_Db_PropertiesUtil.getInstance().compare(
      this.column_Properties,
      gpsSubcriberTmp.column_Properties,
    );
    if (diffString != "") return diffString;

    diffString = Obj_Db_PropertiesUtil.getInstance().compare(
      this.target_Properties,
      gpsSubcriberTmp.target_Properties,
    );
    if (diffString != "") return diffString;

    return diffString;
  }

  toString(): string {
    return (
      "GpsSubscriber [gpsSubscriber_Inst=" +
      this.gpsSubscriber_Inst +
      ", conn_Db_Obj_Lnks=" +
      Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
      ", dxFlow_Obj_Properties=" +
      DxFlow_Obj_PropertiesUtil.getInstance().toString(
        this.dxFlow_Obj_Properties,
      ) +
      ", change_Ind=" +
      this.change_Ind +
      ", error_Cd=" +
      this.error_Cd +
      ", error_Msg=" +
      this.error_Msg +
      ", ref_Id=" +
      this.ref_Id +
      ", ref_Cd=" +
      this.ref_Cd +
      ", fldr_Id=" +
      this.fldr_Id +
      ", column_Properties=" +
      Obj_Db_PropertiesUtil.getInstance().toString(this.column_Properties) +
      ", gps_Subscriber_Properties=" +
      Obj_Db_PropertiesUtil.getInstance().toString(
        this.gps_Subscriber_Properties,
      ) +
      ", target_Properties=" +
      Obj_Db_PropertiesUtil.getInstance().toString(this.target_Properties) +
      "]"
    );
  }
}
